import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createDonationSubscriptionSlice from "./DonationSubscription/store/createDonationSubscriptionSlice";
import donationSubscriptionVoucherSlice from "./DonationSubscription/store/getAllSubscriptionVoucherSlice"
import authSlice from "./Auth/store/authSlice";
import getSettingSlice from "./Settings/store/settingSlice";
import enquiry from '../src/enquiries/enquirySlice'

export const rootReducer = combineReducers({
  enquiry : enquiry,
  createSubscription: createDonationSubscriptionSlice,
  subscriptionVoucher: donationSubscriptionVoucherSlice,
  auth: authSlice,
  getSetting: getSettingSlice,
});

